import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { SharedTranslateModule } from '../../../utils/sharedTranslateModule';
import { WindowRef } from '../../../utils/window';
import { AccoutDetailsResponse } from '../../../shared/models/accountDetailsResponse';
import { AuthorizationService } from '../../authorization/authorization.service';
import {MatIconModule} from '@angular/material/icon';
import { CustomerDetailsList } from '../../../shared/models/CustomerDetailsList';
import { VinDetailsResponse } from '../../../../../src/app/shared/models/VinDetailsResponse';
import { AccountNumber } from '../../../../../src/app/shared/models/accountNumber';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { SessionTimeoutComponent } from '../../sessionTimeout/sessionTimeout.component';
import { DTFHomepageService } from '../../dtfhomepage/dtfhomepage.service';

@Component({
    selector: 'div.dtf-guestpay',
    templateUrl: './guestpay.component.html',
    styles: [],
    imports: [SharedTranslateModule,
        MatPaginator, MatSort, MatTableModule, MatInputModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatDatepickerModule, MatIconModule, MatSortModule, MatPaginatorModule, MatDialogModule,
        MatButtonModule]
    })
export class GuestPayComponent {


  displayCloseIcon = false;
  GuestPay = true;
  reactiveForm: FormGroup;
  AccountNo = '';
  CompanyName = '';
  ZipCode = '';
  azURL: string;
  usUrl: string;
  private _window: WindowRef;
  router: Router;
  isTable = false;
  isForm = true;
  isFrench = false;
  accountDetailsRes: AccoutDetailsResponse[];
  agentView: boolean
  page: string;
  language = '';
  token: string;
  ciamId = sessionStorage.getItem('loginID');
  customerDetailsList: CustomerDetailsList[] = [];
  accountNumber: string = ''; 
  tableLoaded = true;
  bodyLoaded = false;
  vinDetailsRes: VinDetailsResponse[];
  selectedAccountList: AccountNumber[];
  selectedAccount: AccountNumber;
  validationerror = false;
  invalid: boolean=false;
  amounterror = false;
  error = false;
  loading = false;
  failureError = false;

  initColumns: any[] = [
    {
      name: 'account',
      display: 'Account Number',
      dispFormat: ''
    },
    {
      name: 'companyName',
      display: 'Company Name',
      dispFormat: 'companyname'
    },
    {
      name: 'invoiceNumber',
      display: 'Invoice Number',
      dispFormat: ''
    },
    {
      name: 'year',
      display: 'Vehicle Year',
      dispFormat: ''
    },
    {
      name: 'make',
      display: 'Vehicle Make',
      dispFormat: ''
    },
    {
      name: 'model',
      display: 'Vehicle Model',
      dispFormat: ''
    },
    {
      name: 'amountDue',
      display: 'Amount Due',
      dispFormat: 'amountdue'
    },
    {
      name: 'paymentAmount',
      display: 'Payment Amount',
      dispFormat: 'paymentamount'
    },
    {
      name: 'pay',
      display: '',
      dispFormat: 'paybutton'
    }
  
  ];
  displayedColumns: any[] = this.initColumns.map(col => col.name);

  dataSource: MatTableDataSource<CustomerDetailsList>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  form: FormGroup;

  constructor( router: Router, window: WindowRef, public auth: AuthorizationService,
    public dtfhomepageService: DTFHomepageService,private fb: FormBuilder, private cdr: ChangeDetectorRef
  ) {
    this.router = router;
    this._window = window;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.customerDetailsList = [];
    this.dataSource = new MatTableDataSource(this.customerDetailsList);

    this.form = this.fb.group({
      field1: ['', { validators: [Validators.required], updateOn: 'blur' }],
      field2: ['', { validators: [Validators.required], updateOn: 'blur' }],
      field3: ['', { validators: [Validators.required], updateOn: 'blur' }]
    });
  }

  ngOnInit(): void {
    if (sessionStorage.getItem('agentView') == "true") {
      this.agentView = true
    } else {
      this.agentView = false
    }
    this.page = sessionStorage.getItem('page')
    this.isFrench = ('fr-CA' === this.language) ? true : false;
    this.token = sessionStorage.getItem('ciamToken');
  this.GuestpayToggle();

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

 Cancel(){
  this._window.nativeWindow.location.href = this.usUrl + '/home';
 }

 restrictToTwoDecimals(event: KeyboardEvent, currentValue: string) {
  const input = event.target as HTMLInputElement;
  const key = event.key;

  // Allow navigation and editing keys
  if (
    key === 'Backspace' ||
    key === 'Delete' ||
    key === 'ArrowLeft' ||
    key === 'ArrowRight' ||
    key === 'Tab' ||
    key === 'Home' ||
    key === 'End'
  ) {
    return;
  }

  // Allow only digits and decimal point
  if (!/[0-9.]/.test(key)) {
    event.preventDefault();
    return;
  }

  const { selectionStart, selectionEnd, value } = input;
  const start = selectionStart ?? 0;
  const end = selectionEnd ?? 0;

  // Simulate what the input value would look like after this keypress
  const newValue = value.slice(0, start) + key + value.slice(end);

  // If there’s more than one dot, block
  if ((newValue.match(/\./g) || []).length > 1) {
    event.preventDefault();
    return;
  }

  // Check if there are more than 2 digits after the decimal
  const parts = newValue.split('.');
  if (parts.length === 2 && parts[1].length > 2) {
    event.preventDefault();
    return;
  }
}

GuestpayToggle() {
    this.dtfhomepageService.PayToggle().subscribe((res) => {
      for (var i = 0; i < res.length; i++) {
        if (res[i].bannerType === "Pay" && res[i].bannerEnable === "Y" && res[i].bannerExtra === "G") {
          this.GuestPay = false;
        }
      }
    });
  }
Lookup() {

  this.tableLoaded = false;
  this.bodyLoaded = false;
  if (!this.form.invalid) {
    const accountNumber = this.accountNumber.trim().slice(0, -3);
    const zipCode = this.ZipCode;
    const companyName = this.CompanyName;
    const guestPayRequest = {
      agreementNumber: accountNumber,
      scheduleNumber: '1',
      contractType: 'LOAN',
      zipCode: zipCode,
      companyName: companyName
    };
    this.auth.getCustomerDetails(guestPayRequest).subscribe({
      next: (res) => {
        if (res.statusMessage != "Success") {
          this.validationerror = true;
          this.tableLoaded = true;
          this.isTable = false;
        }else{
        if (res && Array.isArray(res)) {
          // If the response is an array, assign it to customerDetailsList
          this.customerDetailsList = res;
        } else {
          // If it's a single object, wrap it in an array
          this.customerDetailsList = [res];
        }

        for (var i = 0; i < this.customerDetailsList.length; i++) {
          if(this.customerDetailsList[i].account !==null)
          this.customerDetailsList[i].account = this.customerDetailsList[i].account + '001';
        }
      
        // Update the table data source
        this.cdr.detectChanges();
        this.dataSource = new MatTableDataSource(this.customerDetailsList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.isTable = true;
        this.isForm = false;
        this.cdr.detectChanges();
        this.tableLoaded = true;
        this.bodyLoaded = true;
      } 
      },
      error: (err) => {
        console.error('Error fetching customer details:', err);  
      }
    
    });
  }else{
    this.cdr.detectChanges();
    this.error = true;
    this.isTable = false; 
    this.tableLoaded = true;
  }
}

  positiveNumberOnly(event): boolean {

    const pattern = /[0-9.,]/;  // Allow only digits, comma, and decimal point
    if (!pattern.test(event.key)) {
      event.preventDefault();
    }

    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode == 45)
      return false;
    return true;


  }

convertToDecimal(element) {
  // Remove non-numeric characters (except dot and minus)
  let rawValue = element.paymentAmount ? element.paymentAmount.replace(/[^0-9.-]+/g, '') : '';

  // Convert to number safely
  let parsedValue = parseFloat(rawValue);

  // Handle NaN or empty input
  if (isNaN(parsedValue) || rawValue === "") {
    parsedValue = 0;
  }

  // Find element in data source
  let index = this.dataSource.data.findIndex((obj: any) => obj.account === element.account);

  // Format the number with 2 decimal places and commas
  this.dataSource.data[index].paymentAmount = this.addComma(parsedValue.toFixed(2));

  // Update the list
  this.customerDetailsList = [...this.dataSource.data];
}

  addComma(value: string): string {
    let [integerPart, decimalPart] = value.split('.');

    // Add commas to the integer part (before the decimal point)
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Join the integer part with the decimal part (if any)
    return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
  }


  HostedCheckout() {
    
    console.log(JSON.stringify(this.customerDetailsList));

    this.invalid=false;

    let amount = parseFloat(this.customerDetailsList[0].paymentAmount.replace(/,/g, ''));

    if(amount === 0 || amount > 2000000){
      this.invalid=true;
      this.amounterror = true;
    }else{
      this.amounterror = false;
      this.invalid = false;
    }

    if(!this.invalid){
    this.loading = true;
   
    const request = {
      "payment_type": "AGREEMENT",
      "line_items": [
        {
          "position": 1,
          "dollarAmount": amount,
          "alfa_agreement_number": this.customerDetailsList[0].account
        }
      ],
      "thirdPartyId": this.customerDetailsList[0].thirdPartyId,
      "userId": this.customerDetailsList[0].companyName,
      "state": this.customerDetailsList[0].state
    }

    console.log(" Payment Request", request);

    this.auth.guestPayPayment(request).subscribe(res => {
      if (res.statusMessage === "FAILURE") {
        this.failureError = true;
      }
      console.log("Hosted Checkout Response", JSON.stringify(res));
      if(res.page_url == 'ExceedAmount'){
        this.amounterror = true;
        this.loading = false;
      }else{
      if (res && res.page_url) {
        this.cdr.detectChanges();
        window.location.href = res.page_url;  // Redirect browser to the URL
        this.loading = false;
      } else {
        console.error('No page_url found in response');
      }
    }
    });
   }
  }


CancelPay(){
  window.location.reload();
  this.isForm = true;
  this.isTable = false;
}


}
